"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbilityDisabledEventArgs = void 0;
const EventType_1 = require("../EventType");
class AbilityDisabledEventArgs {
    constructor(slot) {
        this.slot = slot;
        this.__type = EventType_1.EventType.AbilityDisabled;
        this.__typeName = "AbilityDisabled";
    }
}
exports.AbilityDisabledEventArgs = AbilityDisabledEventArgs;
